import './AnnotationsAtom.css';
export var wrapper = '_145zb630-3-12-1';